import { render, staticRenderFns } from "./ScrollTo.vue?vue&type=template&id=c8f9ff92&lang=pug"
import script from "./ScrollTo.vue?vue&type=script&lang=js"
export * from "./ScrollTo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports